import { lazy } from "react";
import { ERouteMappingKeys } from "./routeKeys";

export const premiumIotRoutes = {
  [ERouteMappingKeys.PREMIUM_IOT]: {
    id: "premium-iot",
    path: "/integrations/premium-iot",
    components: {
      "digital-signage": lazy(() =>
        import("pages/Sections/Integrations/DigitalSignage").then((p) => ({
          default: p.DigitalSignage,
        })),
      ),
      "ev-charging": lazy(() =>
        import("pages/Sections/Integrations/EVCharging").then((p) => ({
          default: p.EVCharging,
        })),
      ),
      "premium-audio": lazy(() =>
        import("pages/Sections/Integrations/PremiumAudio").then((p) => ({
          default: p.PremiumAudio,
        })),
      ),
    },
  },
};
